<template lang="pug">
    .top_nav_container
        img.img_logo(:src="logoImg")
        ul.nav_ul.fr
            li.nav_list(v-for="(item, index) in navList", @click="selTheItem", :class="[index == 0 ? 'act':'']")
                | {{ item }}
        
</template>

<script type="text/javascript">
import logoImg from '@/assets/logo_small.png'

export default {
    name: 'AdTopNav',
    data () {
        return {
            // navList: ['首页', '平台概括', '技术优势', '成功案例'],
            navList: [],
            logoImg
        }
    },
    methods: {
        selTheItem () {

        }
    }
}
</script>

<style lang="sass">
.top_nav_container
    width: 960px
    padding: 20px 0
    margin: 0 auto
.img_logo
    width: 106px
    height: 55px
.nav_ul
    color: #fff
    padding-top: 8px
    font-size: 16px
    line-height: 22px
.nav_list
    float: left
    margin-left: 40px
    cursor: pointer
    &.act
        color: #F8E71C
        border-bottom: 2px solid #F8E71C
    &:hover
        opacity: .8
</style>